const HighlightText = (text, keyword) => {
  if (!keyword) return text;

  const regex = new RegExp(`(${keyword})`, 'gi'); // case-insensitive
  const parts = text.split(regex);

  return parts.map((part, index) =>
    part.toLowerCase() === keyword.toLowerCase() ? (
      <span key={index} style={{ color: '#f50057', fontWeight: 'bold' }}>
        {part}
      </span>
    ) : (
      part
    )
  );
};

export default HighlightText